// app/javascript/controllers/map_controller.js
import { Controller } from "@hotwired/stimulus"
import { Loader } from "@googlemaps/js-api-loader"

export default class extends Controller {
  static values = { 
    apiKey: String,
    location: String,
    countryName: String,
    mapId: { type: String, default: 'DEMO_MAP_ID' } // Optional Map ID for Advanced Markers
  }

  connect() {
    this.loadMap()
  }

  async loadMap() {
    const loader = new Loader({
      apiKey: this.apiKeyValue,
      version: "weekly",
      libraries: ["places", "marker"]
    });

    try {
      await loader.load();
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      const { Geocoder } = await google.maps.importLibrary("geocoding");

      const map = new Map(this.element, {
        zoom: 8,
        center: { lat: -34.397, lng: 150.644 },
        mapId: this.mapIdValue
      });

      this.geocodeAddress(map, Geocoder, AdvancedMarkerElement);
    } catch (error) {
      console.error("Error loading Google Maps:", error);
    }
  }

  geocodeAddress(resultsMap, Geocoder, AdvancedMarkerElement) {
    const geocoder = new Geocoder();
    const address = encodeURIComponent(this.locationValue + ' ' + this.countryNameValue);

    geocoder.geocode({ 'address': address }, (results, status) => {
      if (status === 'OK') {
        resultsMap.setCenter(results[0].geometry.location);
        new AdvancedMarkerElement({
          map: resultsMap,
          position: results[0].geometry.location
        });
      } else {
        console.error('Geocode was not successful for the following reason: ' + status);
      }
    });
  }
}
